import * as o from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/ShoppingBag.es.js";
const a = o.forwardRef((p, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...p, weights: t }));
a.displayName = "ShoppingBagIcon";
const m = a;
export {
  m as ShoppingBag,
  a as ShoppingBagIcon
};
